/**
 * How many darts did that finish take?
 *
 * ASSIST MODE ONLY. Manual mode already has the answer in its three slots, and
 * asking there would be asking a question the marker has just finished
 * answering.
 *
 * Worth the interruption because darts_used is what every per-dart average in
 * the system divides by, and a checkout is the one visit where three is
 * usually wrong. Guessing it would quietly flatter or punish whoever finished
 * on their first dart.
 */

const COUNTS = [1, 2, 3];

export default function CheckoutModal({ playerName, score, darts, onDarts, onConfirm, onCancel }) {
  return (
    <div
      className="hd-modal-veil"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <div
        className="hd-modal hd-checkout"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hd-checkout-title"
        tabIndex={-1}
      >
        <div className="hd-modal-head">
          <h2 className="hd-section-title" id="hd-checkout-title" style={{ margin: 0 }}>
            {playerName} checked out {score}
          </h2>
        </div>

        <div className="hd-modal-body">
          <p className="hd-meta" style={{ marginTop: 0 }}>How many darts?</p>

          <div className="hd-checkout-counts" role="group" aria-label="Darts thrown">
            {COUNTS.map((n) => (
              <button
                key={n}
                type="button"
                className={`hd-key hd-checkout-count ${darts === n ? 'hd-suit-on' : ''}`}
                aria-pressed={darts === n}
                onClick={() => onDarts(n)}
              >
                {n}
              </button>
            ))}
          </div>
        </div>

        <div className="hd-modal-foot">
          <button type="button" className="hd-btn hd-btn-quiet" onClick={onCancel}>
            Back
          </button>
          <button type="button" className="hd-btn hd-btn-primary" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
